import { render, staticRenderFns } from "./budget-list.vue?vue&type=template&id=531c1aa0"
import script from "./budget-list.vue?vue&type=script&lang=js"
export * from "./budget-list.vue?vue&type=script&lang=js"
import style0 from "./budget-list.vue?vue&type=style&index=0&id=531c1aa0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports